"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 2v20l4-4h16V2zm17 11-2.5-1.5L14 13V5h5z"
}), 'CommentBankSharp');